import { render, staticRenderFns } from "./tabComp.vue?vue&type=template&id=a29a52be&"
import script from "./tabComp.vue?vue&type=script&lang=js&"
export * from "./tabComp.vue?vue&type=script&lang=js&"
import style0 from "./tabComp.vue?vue&type=style&index=0&id=a29a52be&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports